import type { LineWithEntities } from '@/types';

export const getCompetitorsLineName = (line: LineWithEntities) => {
  return line.competitors?.map((competitor) => competitor.title).join(' - ');
};
